import { Dispatch } from "@reduxjs/toolkit";
import { ErrorTypes } from "globals/enums";
import { ProctoringRoute, getEndpoint } from "routes/route";
import { setIsPaused, setUiErrorScreen, setUiPauseScreen } from "store/app.slice";

const showPauseProctorScreen = (
  dispatch: Dispatch,
  navigate: any,
  code?: string,
  reason?: string,
  note?: string
) => {
  if (reason || note) {
    dispatch(setUiPauseScreen({ reason: reason ?? "", note: note ?? "" }));
  }

  if (code === "TV-PC-NDC") {
    dispatch(
      setUiErrorScreen({ uiErrorScreen: ErrorTypes.NetworkConnectivityErrDetails as string })
    );
    navigate(getEndpoint(ProctoringRoute.Error));
  } else {
    navigate(getEndpoint(ProctoringRoute.PauseProctor));
  }
  const element = document?.getElementById("proview_root");
  if (element) {
    element.style.display = "flex";
  }
};

const pauseProctor = (
  dispatch: Dispatch,
  navigate: any,
  code: string,
  reason?: string,
  note?: string
) => {
  if (!code) console.log("Missing required argument: code");
  dispatch(setIsPaused({ isPaused: true }));
  showPauseProctorScreen(dispatch, navigate, code, reason, note);
};

const resumeProctor = (dispatch: Dispatch) => {
  dispatch(setIsPaused({ isPaused: false }));
};

export { pauseProctor, resumeProctor, showPauseProctorScreen };
